import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["href"];
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["data-id"];
var _hoisted_6 = ["innerHTML"];
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { useShowPhone } from "@wkComposables/useShowPhone";
import { UserTypologyId } from "@customTypes/UserTypologyId";
import { useMetadataStore } from "@wkWebSrc/js/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'CustodianSupervisorCard',
  props: {
    labels: {},
    agencyItem: {},
    isPhoneShowed: {
      type: Boolean
    },
    realEstateId: {},
    placeId: {},
    price: {},
    typologyName: {}
  },
  setup(__props) {
    var props = __props;
    var {
      wkLabels
    } = useCommonVars();
    var {
      showPhone
    } = useShowPhone();
    var mdStore = useMetadataStore();
    return (_ctx, _cache) => {
      return _ctx.agencyItem ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tw-p-20px tw-rounded tw-mb-20px tw-border-w-secondary tw-border-[1px]", [_ctx.agencyItem.userTypologyId === _unref(UserTypologyId).AUCTION_SUPERVISOR ? 'max-sm:tw-bg-w-lavender' : '']])
      }, [_createElementVNode("h3", {
        class: "tw-text-18 tw-mb-5px",
        innerHTML: _ctx.labels.title
      }, null, 8 /* PROPS */, _hoisted_1), _createElementVNode("a", {
        itemprop: "name",
        class: "tw-text-left tw-block tw-text-16 sm:tw-text tw-font-semibold tw-mb-10px",
        href: _ctx.agencyItem.url
      }, [_createElementVNode("img", {
        class: "tw-object-contain tw-h-[34px] tw-cursor-pointer tw-mb-10px",
        src: "/rest/agency/getAgencyImageByAgencyID/".concat(_ctx.agencyItem.id, "/2"),
        alt: _ctx.agencyItem.name + '- foto - 1'
      }, null, 8 /* PROPS */, _hoisted_3), _createTextVNode(" " + _toDisplayString(_ctx.agencyItem.name), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_2), _ctx.agencyItem.address ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "tw-text-12 tw-mb-5px tw-cursor-default",
        innerHTML: _ctx.agencyItem.address
      }, null, 8 /* PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true), _ctx.isPhoneShowed ? (_openBlock(), _createBlock(BaseButton, {
        key: 1,
        "data-cy": "show-phone-btn-consultant-".concat(_ctx.agencyItem.id),
        "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm tw-flex tw-items-center tw-justify-center",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(showPhone)({
          id: _ctx.realEstateId,
          agencyId: _ctx.agencyItem.id,
          agencyName: _ctx.agencyItem.name,
          subscriptionType: _ctx.agencyItem.subscriptionType,
          auction: true,
          placeID: _ctx.placeId,
          price: _ctx.price,
          typologyName: _ctx.typologyName,
          userTypologyId: _ctx.agencyItem.userTypologyId
        }, _unref(mdStore).pageName, _ctx.agencyItem.displayPhone), ["prevent", "stop"]))
      }, {
        default: _withCtx(() => [_createVNode(_unref(PhoneIcon), {
          width: 16,
          height: 16,
          class: "tw-mr-5px tw-inline-block"
        }), _createElementVNode("span", {
          "data-id": "phone-".concat(_ctx.agencyItem.id)
        }, [_createElementVNode("span", {
          innerHTML: _unref(wkLabels).phone
        }, null, 8 /* PROPS */, _hoisted_6)], 8 /* PROPS */, _hoisted_5)]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data-cy"])) : _createCommentVNode("v-if", true)], 2 /* CLASS */)) : _createCommentVNode("v-if", true);
    };
  }
});